import React from 'react';
import PropTypes from 'prop-types';

import ImageSliderName
  from 'components/dashboard/image-slider/ImageSliderName';
import CommonLinkDeleteButton
  from 'components/common/link-elements/CommonLinkDeleteButton';
import ImageSliderPublishedCheckbox
  from 'components/dashboard/image-slider/ImageSliderPublishedCheckbox';

import './CommonImageSliderHeaderContent.scss';

function CommonImageSliderHeaderContent(props) {
  const { item, deleteImageSlider } = props;

  return (
    <div className="common-image-slider-header-content__component">
      <div className="title">
        <ImageSliderName
          itemId={item.id}
          name={item.name}
        />
      </div>
      <div className="delete">
        <CommonLinkDeleteButton
          linkItem={item}
          deleteFunction={deleteImageSlider}
        />
      </div>
      <div className="published-block">
        <ImageSliderPublishedCheckbox
          isPublished={item.is_published}
          sliderItem={item}
        />
      </div>
    </div>
  );
};

CommonImageSliderHeaderContent.propTypes = {
  deleteImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default CommonImageSliderHeaderContent;
